/*
 * @Author: edvardchen
 * @Date: 2017-11-13 17:28:50
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2020-08-07 16:57:26
 */

// @flow
import cookie from 'js-cookie';
import _ from 'lodash';
import { type Dispatch } from '../types';
/* import {
  track
} from '../../utility';
*/
declare var __CLIENT__: boolean;

export const SET_DOM_TITLE = 'app/SET_DOM_TITLE';

export const RESET_LOCATION = 'app/RESET_LOCATION';

export const RESET_APN = 'app/RESET_APN';

export const SET_UA = 'app/SET_UA';

export const VIDEO_LIST = 'app/VIDEO_LIST';

export const resetAPN = (payload: string) => ({ type: RESET_APN, payload });

export const setDOMTitle = (title: string) => ({ type: SET_DOM_TITLE, payload: title });

export const SET_GRAY_CONFIG = 'article/SET_GRAY_CONFIG';

export const setGrayConfig = (payload: Object) => ({ type: SET_GRAY_CONFIG, payload });

export const resetLocation = (location: string) => ({ type: RESET_LOCATION, payload: location });

export const setUa = (ua: string) => ({ type: SET_UA, payload: ua });

export const setVideoList = (payload: Object) => ({ type: VIDEO_LIST, payload });

export const makeTrack = () => async () => {
  // const { currentChannel, entry } = getState();
  /* track({
    location: location || entry,
    action,
    object,
    id,
    ext,
    ch: ch || currentChannel,
  }); */
};

const COOKIE_KEY = 'NetType';
export const makeGetAPN = () => async (dispatch: Dispatch) => {
  if (!__CLIENT__) {
    return;
  }

  const old = cookie.get(COOKIE_KEY);
  dispatch(resetAPN(old || ''));

  const getType = _.get(window, 'browser.connection.getType');
  if (getType) {
    getType((str) => {
      if (typeof str !== 'string') {
        console.error('getType', str);
        return;
      }
      cookie.set(COOKIE_KEY, str);
      dispatch(resetAPN(str));
    });
  }
  const connectionchange = _.get(window, 'browser.event.connectionchange');
  if (connectionchange) {
    connectionchange((evt) => {
      if (!evt || typeof evt.currentType !== 'string') {
        console.error('connectionchange', evt);
        return;
      }
      cookie.set(COOKIE_KEY, evt.currentType);
      dispatch(resetAPN(evt.currentType));
    });
  }
};
